export const SLICE_AUTH = 'auth';
export const SLICE_LOADING = 'loading';
export const SLICE_MODAL = 'modal';
export const SLICE_MSG = 'msg';
export const SLICE_OVERLAY = 'overlay';
export const SLICE_SIDEBAR = 'sidebar';
export const SLICE_APP_GEN = 'appGen';
export const SLICE_CONSTANTES = 'constantes';
